/* Script Engine theme · small, dependency-free behaviour.
   Every page works without JavaScript; this file only adds motion and convenience.
   Motion respects prefers-reduced-motion and the "Animations" theme setting. */
(() => {
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches || root.dataset.motion === 'off';
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- header: mega menu + mobile drawer ---------- */
  const megaBtn = document.querySelector('[data-mega]');
  const mega = document.getElementById('a-mega');
  const closeMega = () => { if (!megaBtn || !mega) return; megaBtn.setAttribute('aria-expanded', 'false'); mega.classList.remove('open'); };
  if (megaBtn && mega) {
    megaBtn.addEventListener('click', () => {
      const open = megaBtn.getAttribute('aria-expanded') !== 'true';
      megaBtn.setAttribute('aria-expanded', String(open));
      mega.classList.toggle('open', open);
    });
    megaBtn.parentElement.addEventListener('mouseleave', closeMega);
    document.addEventListener('click', e => { if (!e.target.closest('.a-has-mega')) closeMega(); });
  }
  const drawerBtn = document.querySelector('[data-drawer]');
  const drawer = document.getElementById('a-drawer');
  const setDrawer = open => {
    if (!drawerBtn || !drawer) return;
    drawer.hidden = !open;
    drawerBtn.setAttribute('aria-expanded', String(open));
    /* the burger and ✕ icons swap in CSS (aria-expanded); screen readers get "Menu" / "Close" in the visitor's language */
    drawerBtn.setAttribute('aria-label', open ? drawerBtn.dataset.close || 'Close' : drawerBtn.dataset.open || 'Menu');
  };
  if (drawerBtn && drawer) drawerBtn.addEventListener('click', () => setDrawer(drawer.hidden));

  /* ---------- requirements dialog ---------- */
  const dlg = document.getElementById('req');
  const openReq = () => {
    if (!dlg) return false;
    closeMega(); setDrawer(false);
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    const first = dlg.querySelector('input, select, textarea');
    if (first) first.focus();
    return true;
  };
  if (dlg) {
    dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    const x = dlg.querySelector('[data-close-req]');
    if (x) x.addEventListener('click', () => dlg.close());
    /* re-open the pop-up if the form came back with errors (not on the contact page, which has its own form) */
    if (dlg.querySelector('[data-open-on-load]') && !document.getElementById('requirements')) openReq();
  }

  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeMega(); if (drawer && !drawer.hidden) setDrawer(false); } });

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', e => {
    const more = e.target.closest('[data-more]');
    if (more) {
      const q = more.previousElementSibling;
      const open = q.classList.toggle('open');
      more.setAttribute('aria-expanded', String(open));
      if (!more.dataset.label) more.dataset.label = more.textContent;
      more.textContent = open ? more.dataset.less : more.dataset.label;
      return;
    }
    const req = e.target.closest('[data-open-req]');
    if (req) {
      /* On the contact page, links scroll to the form there instead of opening the dialog. */
      if (document.getElementById('requirements') && req.getAttribute('href')) return;
      if (openReq()) e.preventDefault();
      return;
    }
    const sw = e.target.closest('[data-switch]');
    if (sw) { sw.setAttribute('aria-checked', String(sw.getAttribute('aria-checked') !== 'true')); return; }
    const copy = e.target.closest('[data-copy]');
    if (copy) {
      const done = () => { const t = copy.getAttribute('aria-label'); copy.setAttribute('aria-label', copy.dataset.copied || 'Link copied'); setTimeout(() => copy.setAttribute('aria-label', t), 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.copy || location.href).then(done, () => {});
      return;
    }
    const prev = e.target.closest('[data-rev-prev]'), next = e.target.closest('[data-rev-next]');
    if (prev || next) {
      const section = (prev || next).closest('section');
      const track = section && section.querySelector('[data-rev-track]');
      if (!track || !track.firstElementChild) return;
      const w = track.firstElementChild.getBoundingClientRect().width + 18;
      track.scrollBy({ left: (next ? 1 : -1) * w, behavior: reduce ? 'auto' : 'smooth' });
    }
  });

  /* ---------- homepage hero micro-interactions ---------- */
  function initHero(scope) {
    $$('[data-heart]', scope).forEach(h => h.addEventListener('click', () => {
      const on = h.getAttribute('aria-pressed') !== 'true';
      h.setAttribute('aria-pressed', String(on));
      h.setAttribute('aria-label', on ? h.dataset.on || 'Saved to wishlist' : h.dataset.off || 'Save to wishlist');
      h.classList.remove('pop'); void h.offsetWidth; h.classList.add('pop');
      const card = h.closest('.a-pdp');
      const st = card && card.querySelector('[data-heart-status]');
      if (st) st.textContent = on ? st.dataset.on : st.dataset.off;
    }));
    const bell = scope.querySelector('[data-bell]');
    if (bell && !reduce) setInterval(() => {
      if (document.hidden) return;
      bell.classList.remove('ring'); void bell.offsetWidth; bell.classList.add('ring');
    }, 5000);
  }

  /* ---------- gallery, pricing toggle, before/after ---------- */
  function initWidgets(scope) {
    $$('[data-gallery]', scope).forEach(g => {
      const main = g.querySelector('[data-gallery-main]');
      const btns = $$('.p-thumbs button', g);
      btns.forEach(b => b.addEventListener('click', () => {
        btns.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        if (!main) return;
        const img = b.querySelector('img');
        main.srcset = b.dataset.srcset || '';
        main.src = b.dataset.src || img.src;
        main.alt = b.dataset.alt || b.getAttribute('aria-label') || '';
      }));
    });
    $$('[data-bill]', scope).forEach(g => g.addEventListener('click', e => {
      const b = e.target.closest('[data-period]');
      if (!b) return;
      $$('[data-period]', g).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      $$('[data-m]', g.closest('section')).forEach(el => { el.textContent = el.dataset[b.dataset.period]; });
    }));
    $$('[data-ba]', scope).forEach(ba => {
      const r = ba.querySelector('[data-ba-range]');
      if (!r) return;
      const set = v => { r.value = v; ba.style.setProperty('--pos', v + '%'); };
      r.addEventListener('input', () => ba.style.setProperty('--pos', r.value + '%'));
      if (reduce) return;
      /* one gentle sweep the first time the slider scrolls into view */
      const io = new IntersectionObserver(([en]) => {
        if (!en.isIntersecting) return;
        io.disconnect();
        const keys = [[0, 50], [700, 28], [1500, 72], [2200, 50]], t0 = performance.now();
        const step = t => {
          const d = t - t0, i = keys.findIndex(k => k[0] > d);
          if (i === -1) { set(50); return; }
          const [ta, va] = keys[i - 1], [tb, vb] = keys[i], p = (d - ta) / (tb - ta);
          const q = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
          set(Math.round(va + (vb - va) * q));
          requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }, { threshold: .6 });
      io.observe(ba);
    });
  }

  /* ---------- filters + search (case studies, blog) ---------- */
  function initFilters(scope) {
    $$('[data-filter-scope]', scope).forEach(box => {
      const apply = () => {
        const on = box.querySelector('[data-f][aria-pressed="true"]');
        const f = on ? on.dataset.f : 'all';
        const input = box.querySelector('[data-search]');
        const q = input ? input.value.trim().toLowerCase() : '';
        let n = 0;
        $$('[data-cat]', box).forEach(el => {
          const ok = (f === 'all' || el.dataset.cat.split(' ').includes(f)) && (!q || el.textContent.toLowerCase().includes(q));
          el.hidden = !ok;
          if (ok) n++;
        });
        const empty = box.querySelector('[data-empty]');
        if (empty) empty.hidden = n > 0;
      };
      const bar = box.querySelector('[data-filter]');
      if (bar) bar.addEventListener('click', e => {
        const b = e.target.closest('[data-f]');
        if (!b) return;
        $$('[data-f]', box).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        apply();
      });
      const s = box.querySelector('[data-search]');
      if (s) s.addEventListener('input', apply);
    });
  }

  /* ---------- reveal on scroll (content is never hidden, it only moves) ---------- */
  let rio;
  function initReveal(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    rio = rio || new IntersectionObserver(es => es.forEach(en => {
      if (!en.isIntersecting) return;
      en.target.classList.remove('pre'); en.target.classList.add('in');
      rio.unobserve(en.target);
    }), { rootMargin: '0px 0px -6% 0px' });
    $$('[data-reveal]', scope).forEach(el => {
      if (el.getBoundingClientRect().top < innerHeight * .95) return;
      el.classList.add('pre');
      rio.observe(el);
    });
  }

  /* ---------- counters: show the final number at rest, count up once when scrolled into view ---------- */
  let cio;
  function initCounters(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    cio = cio || new IntersectionObserver(es => es.forEach(en => {
      if (!en.isIntersecting) return;
      const el = en.target, end = parseFloat(el.dataset.count), t0 = performance.now();
      cio.unobserve(el);
      if (!isFinite(end)) return;
      const step = t => {
        const p = Math.min(1, (t - t0) / 1400);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step); else el.textContent = el.dataset.count;
      };
      requestAnimationFrame(step);
    }), { threshold: .6 });
    $$('[data-count]', scope).forEach(el => { if (el.getBoundingClientRect().top > innerHeight) cio.observe(el); });
  }

  /* ---------- "On this page" contents: highlight the section in view ---------- */
  function initToc(scope) {
    $$('[data-toc]', scope).forEach(toc => {
      if (!('IntersectionObserver' in window)) return;
      const links = $$('a[href^="#"]', toc);
      const map = new Map(links.map(a => [decodeURIComponent(a.getAttribute('href').slice(1)), a]));
      const io = new IntersectionObserver(es => es.forEach(en => {
        if (!en.isIntersecting) return;
        links.forEach(l => l.classList.remove('active'));
        const a = map.get(en.target.id);
        if (a) a.classList.add('active');
      }), { rootMargin: '-15% 0px -75% 0px' });
      map.forEach((a, id) => { const t = document.getElementById(id); if (t) io.observe(t); });
    });
  }

  /* ---------- reading progress bar (articles) ---------- */
  function initProgress() {
    const prog = document.querySelector('[data-progress]');
    const art = document.querySelector('[data-progress-target]');
    if (!prog || !art) return;
    prog.hidden = false;
    const bar = prog.firstElementChild;
    const update = () => {
      const r = art.getBoundingClientRect();
      bar.style.width = (Math.min(1, Math.max(0, (innerHeight * .3 - r.top) / (r.height - innerHeight * .4))) * 100).toFixed(1) + '%';
    };
    addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- header: switch to the Menu button when the full menu doesn't fit on one line (longer translated words) ---------- */
  const header = document.querySelector('.a-header');
  const headerIn = header && header.querySelector('.a-header-in');
  const fitHeader = () => {
    if (!headerIn) return;
    header.classList.remove('is-compact');
    if (headerIn.scrollWidth > headerIn.clientWidth + 1) header.classList.add('is-compact');
  };
  fitHeader();
  addEventListener('resize', fitHeader);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHeader);

  /* ---------- language picker: switch as soon as a language is chosen (the form still has a submit button without JS) ---------- */
  document.addEventListener('change', e => {
    const sel = e.target.closest('[data-lang-select]');
    if (sel && sel.form) sel.form.submit();
  });

  /* ---------- long reviews: cut to a few lines with "…", and show "Read more" only when text was cut ---------- */
  function initClamp(scope) {
    $$('[data-clamp]', scope).forEach(q => {
      const btn = q.nextElementSibling;
      if (!btn || !btn.matches('[data-more]')) return;
      q.classList.add('is-clamped');
      if (q.classList.contains('open')) return;
      btn.hidden = q.scrollHeight <= q.clientHeight + 1;
    });
  }
  let clampT;
  addEventListener('resize', () => { clearTimeout(clampT); clampT = setTimeout(() => initClamp(document), 150); });
  addEventListener('load', () => initClamp(document));

  /* ---------- mobile CTA bar: appears once the hero has scrolled away ---------- */
  function initMobileBar() {
    const mbar = document.querySelector('[data-mbar]');
    if (!mbar) return;
    const hero = document.querySelector('[data-hero]');
    if (!hero || !('IntersectionObserver' in window)) { mbar.classList.add('show'); return; }
    new IntersectionObserver(([en]) => mbar.classList.toggle('show', !en.isIntersecting)).observe(hero);
  }

  function init(scope) {
    initHero(scope);
    initWidgets(scope);
    initFilters(scope);
    initReveal(scope);
    initCounters(scope);
    initToc(scope);
    initClamp(scope);
  }

  init(document);
  initProgress();
  initMobileBar();

  /* Theme Editor: re-run section behaviour when a section is added or changed. */
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
